export default __webpack_public_path__ + "static/media/include_0_female@3x.e52441c3.jpg";